import React from 'react';
import styles from './IconButton.module.scss';
import Tooltip from '../../../../Components/Popup/Tooltip';
import Text from '../../../../Components/Base/Text/Text';

interface Props {
	icon: string;
	onClick: (event: React.MouseEvent<HTMLDivElement>) => void;
	tooltip?: string;
}

const IconButton: React.FC<Props> = ({ icon, onClick, tooltip }) => {
	const component = (
		<div className={styles.wrapper} onClick={onClick}>
			<img className={styles.icon} src={icon} alt='icon' />
		</div>
	);

	if (tooltip) {
		return (
			<Tooltip trigger={component}>
				<Text tx={tooltip} />
			</Tooltip>
		);
	}

	return component;
};

export default IconButton;
